import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate, useLocation } from 'react-router-dom';

import PageTitleSection from '../../components/PageTitleSection/PageTitleSection';
import PageContentContainer from '../../components/PageContentContainer/PageContentContainer';
import CustomTabs from '../../components/CustomTabs/CustomTabs';
import useAuthRoles from '../../hooks/useAuthRoles';
import GeneralTab from './GeneralTab/GeneralTab';

function OrganisationSettingsPage(): React.ReactElement {
  const location = useLocation();
  const { userIsAdmin } = useAuthRoles();
  const [selectedTab, setSelectedTab] = React.useState('general');

  if (!userIsAdmin()) {
    return <Navigate to='/chats' state={{ from: location }} replace />;
  }

  return (
    <>
      <Helmet>
        <title>Japeto - Organisation</title>
      </Helmet>
      <PageTitleSection title='Organisation' />
      <PageContentContainer>
        <CustomTabs
          tabs={[
            {
              label: 'General',
              value: 'general',
              content: <GeneralTab />
            }
          ]}
          defaultValue='general'
          value={selectedTab}
          onValueChange={setSelectedTab}
          hasContentBox
        />
      </PageContentContainer>
    </>
  );
}

export default OrganisationSettingsPage;
